import {IMailQueueAdminListEntry, MailQueueEntryState} from "@/models/mail-queue/MailQueueAdminModels";
import AxiosService from "@/services/AxiosService";
import IMailQueueServiceAdmin from "@/services/definition/IMailQueueServiceAdmin";
import Vue from "vue";
import IPaginatedResponse from "@/models/IPaginatedResponse";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import MailQueueAdminListFilter from "@/models/mail-queue/MailQueueAdminListFilter";

export default class AxiosMailQueueServiceAdmin extends AxiosService implements IMailQueueServiceAdmin {

	public static readonly BASE_URL = '/admin/mail-queue';

	protected defineBaseUrl(): string {
		return AxiosMailQueueServiceAdmin.BASE_URL;
	}

	public mailQueueEntries(filter: MailQueueAdminListFilter | null, options: AsiListTableOptions | null): Promise<IPaginatedResponse<IMailQueueAdminListEntry>> {
		return Vue.$axios.get<IPaginatedResponse<IMailQueueAdminListEntry>>(this.url(), {
			params: {
				...filter,
				...options
			}
		}).then(res => res.data);
	}

	public updateMailQueueEntryState(id: string, state: MailQueueEntryState): Promise<null> {
		return Vue.$axios.patch<null>(this.url(`/${id}/state`), { state }).then(res => res.data);
	}
}